module.exports = __webpack_public_path__ + "img/SDG-04-EN-INVERTED.db0ffdea.png";